import React from 'react';
import './styles.css';

export type IconName =
  | 'mail'
  | 'lock'
  | 'user'
  | 'phone'
  | 'search'
  | 'bell'
  | 'logout'
  | 'menu'
  | 'heart'
  | 'sun'
  | 'moon'
  | 'eye'
  | 'eye-off'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'play'
  | 'pause'
  | 'volume-mute'
  | 'volume-off';

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = ''
}) => {
  // Renderiza o ícone SVG com base no nome
  const renderSvgIcon = () => {
    const svgProps = {
      width: size,
      height: size,
      fill: "none",
      stroke: color,
      strokeWidth: 2,
      strokeLinecap: "round" as "round",
      strokeLinejoin: "round" as "round",
      viewBox: "0 0 24 24"
    };

    switch (name) {
      case 'heart':
        return (
          <svg {...svgProps}>
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        );
      case 'mail':
        return (
          <svg {...svgProps}>
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        );
      case 'lock':
        return (
          <svg {...svgProps}>
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        );
      case 'user':
        return (
          <svg {...svgProps}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        );
      case 'phone':
        return (
          <svg {...svgProps}>
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
        );
      case 'sun':
        return (
          <svg {...svgProps}>
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        );
      case 'moon':
        return (
          <svg {...svgProps}>
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        );
      case 'eye':
        return (
          <svg {...svgProps}>
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        );
      case 'eye-off':
        return (
          <svg {...svgProps}>
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
          </svg>
        );
      case 'logout':
        return (
          <svg {...svgProps}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        );
      case 'chevron-down':
        return (
          <svg {...svgProps}>
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        );
      case 'chevron-right':
        return (
          <svg {...svgProps}>
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        );
      case 'chevron-left':
        return (
          <svg {...svgProps}>
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        );
      case 'menu':
        return (
          <svg {...svgProps}>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        );
      case 'bell':
        return (
          <svg {...svgProps}>
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        );
      case 'search':
        return (
          <svg {...svgProps}>
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        );
      case 'play':
        return (
          <svg {...svgProps}>
            <path d="M5 3l14 9-14 9V3z"></path>
          </svg>
        );
      case 'pause':
        return (
          <svg {...svgProps}>
            <rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        );
      case 'volume-mute':
        return (
          <svg {...svgProps}>
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>
          </svg>
        );
      case 'volume-off':
        return (
          <svg {...svgProps}>
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          </svg>
        );
      default:
        console.warn(`Icon "${name}" not found`);
        return null;
    }
  };

  return (
    <span className={`icon-wrapper ${className}`}>
      {renderSvgIcon()}
    </span>
  );
};

export default Icon;